module.exports = __webpack_public_path__ + "257cbbff59ee2f1314a04bc0ed5a4205.jpg";